import type { MetricType, MonitorStatus } from '@repo/api-codegen';
import { MONITOR_ICON_MAPPING } from '../constants/monitor';

function formatMonitorFreshnessValue(value: number): string {
	const absValue = Math.abs(value);
	let unit = 'seconds';
	let divisor = 1;

	if (absValue < 600) {
		// seconds
	} else if (absValue < 3600) {
		unit = 'mins';
		divisor = 60;
	} else if (absValue < 86400) {
		unit = 'hours';
		divisor = 3600;
	} else {
		unit = 'days';
		divisor = 86400;
	}

	let formattedValue: string;
	if (unit === 'hours') {
		formattedValue = (value / divisor).toFixed(1);
	} else {
		formattedValue = (value / divisor).toFixed(0);
	}

	return `${formattedValue} ${unit}`;
}

function formatMonitorPercentageValue(value: number): string {
	let formattedValue = '';
	if (value < 1) {
		formattedValue = value.toFixed(2);
	} else if (value < 10) {
		formattedValue = value.toFixed(1);
	} else {
		formattedValue = value.toFixed(0);
	}
	return `${formattedValue}%`;
}

function formatMonitorRowCountValue(value: number): string {
	return `${new Intl.NumberFormat('en-US').format(parseInt(value.toFixed(0)))} rows`;
}

function formatNumberWithCommas(value: number): string {
	const absValue = Math.abs(value);
	let formatted = '';

	if (value === 0) {
		formatted = '0';
	} else if (absValue < 0.01) {
		formatted = value.toFixed(4);
	} else if (absValue < 0.1) {
		formatted = value.toFixed(2);
	} else if (absValue < 1) {
		formatted = value.toFixed(2);
	} else if (absValue < 10) {
		formatted = value.toFixed(1);
	} else {
		formatted = value.toFixed(0);
	}

	return new Intl.NumberFormat('en-US').format(parseFloat(formatted));
}

export const formatMonitorMetricValue = (
	metricType: MetricType,
	value: number
) => {
	switch (metricType) {
		case 'freshness':
		case 'job_duration':
			return formatMonitorFreshnessValue(value);
		case 'null_percentage':
		case 'unique_percentage':
		case 'job_success_rate':
		case 'job_error_rate':
			return formatMonitorPercentageValue(value);
		case 'row_count':
			return formatMonitorRowCountValue(value);
		default:
			return formatNumberWithCommas(value);
	}
};

export function isValidMonitorStatus(
	status?: string | null | undefined
): status is MonitorStatus {
	if (!status) {
		return false;
	}

	return typeof status === 'string' && status in MONITOR_ICON_MAPPING;
}
